export const CREATE_USER_FORM_EMAIL = 'email'
export const CREATE_USER_FORM_NAME = 'name'
export const CREATE_USER_FORM_ADMIN = 'admin'
export const CREATE_USER_FORM_IS_PASSIVE = 'isPassive'



// WEBPACK FOOTER //
// ./src/constants/CreateUserFormFieldName.tsx